"use client";

import React from "react";
import {
  formatRatingValue,
  formatSignedRatingValue,
} from "~/lib/formatPercent";

type Props = {
  earnedPoints: number;
  maxPoints: number;
  className?: string;
};

function getEarnedPointsClassName(value: number): string | undefined {
  const rounded = Math.round(value * 10) / 10;

  if (rounded > 0) return "text-green-500";
  if (rounded < 0) return "text-red-500";
  return undefined;
}

export default function RowPoints({
  earnedPoints,
  maxPoints,
  className = "text-muted-foreground",
}: Props) {
  return (
    <span className={className}>
      <span className={getEarnedPointsClassName(earnedPoints)}>
        {formatSignedRatingValue(earnedPoints)}
      </span>
      <span>{` из ${formatRatingValue(maxPoints)}`}</span>
    </span>
  );
}
